module.exports = __webpack_public_path__ + "static/banner.spacesite-45fc6579583c7b57f65875aececd5dcf.png";